import React, { Component } from 'react'

export default class NewWindow extends Component {
  render() {
    return (
      <div>NewWindow</div>
    )
  }
}
